import { Card, CardContent } from '@/components/ui/Card'

interface InfoCardProps {
  label: string;
  value: string | number;
  subValue?: string | number | null;
}

export function InfoCard({ label, value, subValue }: InfoCardProps) {
  return (
    <Card>
      <CardContent className="p-2">
        <div className="text-sm font-semibold mb-2 text-zinc-500 dark:text-zinc-400">
          {label}
        </div>
        <div className="text-xl font-black text-zinc-700 dark:text-zinc-300 truncate" title={String(value)}>
          {value}
        </div>
        {subValue && (
          <div className="text-sm mt-1.5 text-zinc-400 dark:text-zinc-500 truncate" title={String(subValue)}>
            {subValue}
          </div>
        )}
      </CardContent>
    </Card>
  )
}
